(function ($) {
    $(document).ready(function () {
        
        function reInitWishlist(variant, button) {
            const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
            if (wishlist) {
                let array = JSON.parse(wishlist);
                if(array.filter(item => item.variant === `${variant}`).length > 0) {
                    $(button).addClass('active');
                } else {
                    $(button).removeClass('active');
                }
            }
    
            const event = new CustomEvent('shopify-wishlist:button-changed');
            document.dispatchEvent(event);
        }

        if($('.product').length) {
            $(document).on('click', 'variant-radios label', function() {   
                console.log('1')
                let wishlist = $('.product .product__wishlist');

                setTimeout(function() {
                    fetch(`${$(location).attr("href")}&section_id=${$('.pr-custom__variants').attr('section-id')}`)
                    .then((response) => response.text())
                    .then((responseText) => {
                        const html = $($.parseHTML(responseText))
                        html.each(function(){      
                            let newWishlist = $(this).find('.card-prod__wishlist');
                            let newBtnWishlist = $(this).find('.wishlist-button');
                            wishlist.html(newWishlist);
                            reInitWishlist($(newBtnWishlist).data('variant-id'), newBtnWishlist);
                        });
                    });
                },200);
            });
        }

        $(document).on('click', '.quick-add__submit', function() {
            for (let i = 0; i < 20 ; i++) {
                setTimeout(function() {
                    if($('.quick-add-modal__content-info').find('.product__wishlist').length) {
                        $($('.quick-add-modal__content-info').find('.product__wishlist')).remove();
                    }
                },200*i);
            }
        });

        $(document).on('click', '.faq__question', function() {
            if($(this).parent().hasClass('m-block-active')) {
                $(this).parent().removeClass('m-block-active');
            } else {
                $(this).parent().addClass('m-block-active');
                if ($(window).width() > 990) {
                    $('html, body').animate({
                        scrollTop: $(this).parent().offset().top - 40
                    }, 1000);
                } else {
                    $('html, body').animate({
                        scrollTop: $(this).parent().offset().top - 20
                    }, 1000);
                }
            }

        });

        if($('#shopify-product-reviews').length) {

            function updateText() {
                if($('.spr-summary-caption').text() != 'No reviews yet') {
                    if( $('.spr-review-header-title').length) {
                        // $('.spr-review-header-title').text('Rezension');
                        $('.spr-header-title').text('Kundenbewertungen');
                        $('.spr-review-reportreview').text('Als unangemessen melden');
                        $('.spr-summary-actions-newreview').text('Eine Rezension schreiben');
                        $('.spr-pagination-next a').text('Weiter');
                      // $('.spr-pagination-prev a').text('Weiter');

                        let el = $('.spr-summary-actions-togglereviews').text();
                        let numEl = parseInt(el.match(/\d+/));
                        $('.spr-summary-actions-togglereviews').text(`Basierend auf ${numEl} Bewertungen`);
                      newReviewTranslate();
                    } else {
                        setTimeout(function() {
                            updateText();
                        },1000);
                    }
                } else if($('.spr-summary-caption').text() === 'No reviews yet') {
                  $('.spr-header-title').text('Kundenbewertungen');
                  $('.spr-summary-actions-newreview').text('Eine Rezension schreiben');
                  $('.spr-summary-caption').text('Bisher keine Rezensionen');
                  $('.spr-stars + .spr-stars').text('Keine Rezensionen');
                  newReviewTranslate();
                }
            }

          function newReviewTranslate() {
            let newReviewForm = $('.new-review-form');
            if(newReviewForm.length) {
              $('.spr-form-title').text('Bewertung schreiben');
              $('.spr-form-contact-name .spr-form-input').attr('placeholder', 'Gib deinen Namen an');
              $('.spr-form-contact-email label').text('E-Mail');
              $('.spr-form-contact-email .spr-form-input').attr('placeholder', 'Trage deine E-Mailadresse ein');
              $('.spr-form-review-rating label').text('Bewertung');
              $('.spr-form-review-title .spr-form-input').attr('placeholder', 'Wähle einen passenden Titel');
              $('.spr-form-review-body label').text('Ihren Bewertungstext');
              $('.spr-form-review-body .spr-form-input textarea').attr('placeholder', 'Beschreibe deine Erfahrung');
              $('.spr-form-actions [type="submit"]').val('Bericht schreiben');
            }
            
          }

            updateText();

            $(document).on('click', '.spr-pagination-page a', function() {
                setTimeout(function() {
                    updateText();
                },1000);
            });
        }

      
        $(document).on('click', '#Details-menu-drawer-container', function() {
            if($(this).hasClass('m-open')) {
                $('body').removeClass('fixed');
                $(this).removeClass('m-open')
            } else {
                $('body').addClass('fixed');
                $(this).addClass('m-open')
            }
        });

       function formatNumber(elements) {
            let prefix = '.notification-banner__date-'
            elements.map(element => {
                let elSelector = prefix + element,
                    innerText = $(elSelector).text();
                if($(elSelector).text().length < 2) {
                    $(elSelector).text(`0${innerText}`)
                }
            })
        }

      formatNumber(['day', 'month', 'hour', 'minute']);
      
      function accountToggle() {
            let accountToggle = document.querySelector('.account-toggle'),
                accountDropdown = document.querySelector('.account-dropdown');

            accountToggle.addEventListener('click', function (e) {
                e.preventDefault();
                if (accountDropdown.classList.contains('dropdown-active') === true) {
                    accountDropdown.classList.remove('dropdown-active');
                } else {
                    accountDropdown.classList.add('dropdown-active');
                }
            });

            window.addEventListener('click', function (e) {
                if (e.target.closest('.account-container') === null) {
                    accountDropdown.classList.remove('dropdown-active');
                }
            })
        }

        accountToggle();

        // if($('.js-filter').length) {
        //     $('.js-filter[data-index="3"] .list-menu__item.facets__item').each(function() {
        //         let name = $(this).find('.visually-hidden').text();
        //         if(name.indexOf('Dr.') < 0 ){
        //             $(this).css({display:'none'})
        //         }
        //     })
        // }
    });
})(jQuery);
